// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Cjr0","main":"_1g1q8","viewer_classic":"_2tYB9","viewerClassic":"_2tYB9","viewer_x":"qHn88","viewerX":"qHn88"};